import React, { createContext, useContext, useState, useEffect } from 'react';

const ComparisonContext = createContext();

export const useComparison = () => {
  const context = useContext(ComparisonContext);
  if (!context) {
    throw new Error('useComparison must be used within ComparisonProvider');
  }
  return context;
};

export const ComparisonProvider = ({ children }) => {
  const [selectedVehicles, setSelectedVehicles] = useState([]);

  // Load from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem('comparisonVehicles');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setSelectedVehicles(parsed);
      } catch (error) {
        console.error('Error loading comparison vehicles:', error);
      }
    }
  }, []);

  // Save to localStorage whenever selection changes
  useEffect(() => {
    localStorage.setItem('comparisonVehicles', JSON.stringify(selectedVehicles));
  }, [selectedVehicles]);

  const addVehicle = (vehicle) => {
    if (selectedVehicles.length >= 3) {
      return { success: false, message: 'Maximum 3 vehicles can be compared' };
    }
    
    if (selectedVehicles.some(v => v.vehicle_id === vehicle.vehicle_id)) {
      return { success: false, message: 'Vehicle already in comparison' };
    }

    setSelectedVehicles([...selectedVehicles, vehicle]);
    return { success: true, message: 'Vehicle added to comparison' };
  };

  const removeVehicle = (vehicleId) => {
    setSelectedVehicles(selectedVehicles.filter(v => v.vehicle_id !== vehicleId));
  };

  const clearAll = () => {
    setSelectedVehicles([]);
  };

  const isSelected = (vehicleId) => {
    return selectedVehicles.some(v => v.vehicle_id === vehicleId);
  };

  const value = {
    selectedVehicles,
    addVehicle,
    removeVehicle,
    clearAll,
    isSelected,
    count: selectedVehicles.length,
    canAddMore: selectedVehicles.length < 3
  };

  return (
    <ComparisonContext.Provider value={value}>
      {children}
    </ComparisonContext.Provider>
  );
};
